import { Directive, effect, ElementRef, inject, input } from '@angular/core';

@Directive({
  selector: '[phoneLink]'
})
export class PhoneLinkDirective {
  private el = inject(ElementRef);
  phoneLink = input<string | undefined>(undefined)

  constructor() {
    effect(() => {
      const inp = this.phoneLink()
      if (! inp) return

      let pl = inp.trim()

      // altes format manchmal mit (0) - weg damit
      pl = pl.replace('(0)', '')

      // validate length
      if (pl.length < 7) {
        console.warn('Given telephone number is too short!')
        return
      }

      // validate numbers and + only to avoid xss
      if (! new RegExp("^[0-9\+\\s-]+$").test(pl)) {
        return
      }

      // format local number to international format
      if (pl[0] == "0") {
        if (pl[1] != "0") {
          pl = '+43' + pl.substring(1)
        }
      }

      // show given value as text and normalized number in link
      this.el.nativeElement.href = 'tel:' + pl.replace(/\s|-/g, '')
      this.el.nativeElement.innerHTML = pl
      this.el.nativeElement.addEventListener('click', (e: Event) => {
        e.stopPropagation()
      })
    })
  }
}
